import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { IMAGES, CONTACT } from '../constants/images';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white relative">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-xl inline-block">
              <img src={IMAGES.logo} alt="Angionova Clinic - Dr Punit Mahajan" className="h-24 w-auto" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Dr. Punit Pushkar Mahajan - Fellowship-trained Interventional Radiologist providing minimally invasive treatments across Mumbai.
            </p>
            <div className="flex items-center space-x-2 pt-2">
              <div className="flex items-center justify-center px-3 py-1.5 bg-amber-600 rounded-md">
                <span className="text-white font-bold text-xs tracking-wider">FVIR</span>
              </div>
              <span className="text-xs text-slate-400">with Distinction</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-500">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">About Dr. Punit</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Our Services</Link></li>
              <li><Link to="/qualifications" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Qualifications</Link></li>
              <li><Link to="/testimonials" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Patient Reviews</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-500">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services/leg-foot-care" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Leg & Foot Care</Link></li>
              <li><Link to="/services/liver-gi" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Liver & GI Interventions</Link></li>
              <li><Link to="/services/kidney-dialysis" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Kidney & Dialysis Access</Link></li>
              <li><Link to="/services/womens-health" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Women's Health</Link></li>
              <li><Link to="/services/emergency" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">Emergency Interventions</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-500">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                <div>
                  <a href={`tel:${CONTACT.phone}`} className="text-slate-400 hover:text-amber-500 transition-colors text-sm block">
                    {CONTACT.phone}
                  </a>
                  <span className="text-xs text-slate-500">WhatsApp Available</span>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <p>Bombay Hospital & MRC</p>
                  <p className="text-xs text-slate-500">Marine Lines, Mumbai</p>
                </div>
              </li>
              <li>
                <a 
                  href={CONTACT.gmb} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm text-slate-400 hover:text-amber-500 transition-colors"
                >
                  Find us on Google Maps <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Angionova Clinic. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm">
              Dr. Punit Mahajan - MD | DNB | FVIR | CCNR | MNAMS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
